import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $small?: boolean; showFeedback?: boolean }>`
  ${({ theme, $small, showFeedback = false }) => css`
    input,
    textarea,
    select {
      display: block;
      position: relative;
      width: 100%;
      font-size: ${$small ? '1.2' : '1.4'}rem;
      font-weight: ${theme.font.weight.regular};
      background: ${showFeedback ? '#fce5e1' : '#f6f6f6'};
      border-radius: 0.5rem;
      padding: ${$small ? '1.2' : '1.6'}rem ${$small ? '1.4' : '1.9'}rem;
      border: 0.2rem solid #f6f6f6;
      transition: ${theme.transition.default};

      &::placeholder {
        color: #4d4d4d;
      }

      &:focus {
        border-color: #4d4d4d;
      }
    }

    label {
      font-size: 1.4rem;
      font-weight: ${theme.font.weight.regular};
      color: ${theme.color.primary};
      margin-bottom: 0.5rem;
      display: block;
    }
  `}
`;

export const LabelContainer = styled.div<{ afterLabel?: string }>`
  ${({ afterLabel }) => css`
    display: flex;
    align-items: flex-start;
    position: relative;
    width: fit-content;

    img {
      width: 1.6rem;
      height: auto;
      margin-left: 0.8rem;
    }

    ${afterLabel &&
    css`
      :hover:after {
        content: '${afterLabel}';
        position: absolute;
        background: #ffffff;
        color: #848484;
        font-size: 1.2rem;
        padding: 0.8rem;
        /* transform: translate(45%, -100%); */
        border: 1px solid #c4c4c4;
        border-radius: 0.4rem;
        left: 80px;
        top: -40px;
        z-index: 1;
        width: max-content;
      }
    `}
  `}
`;
